import type { ViewTemplate } from '@microsoft/fast-element'
import { html, ref, slotted, when } from '@microsoft/fast-element'
import type { FoundationElementTemplate } from '@microsoft/fast-foundation'
import type { ProductUgc, ProductUgcDefinitionOptions } from './product-ugc.element'

/**
 * The template for the {@link ProductUgc} component.
 * @public
 */
export const ProductUgcTemplate: FoundationElementTemplate<
  ViewTemplate<ProductUgc>,
  ProductUgcDefinitionOptions
> = (context, definition) => {
  // TODO: Use the definition options to set the template

  return html`
    <template>
      ${when(
        (x) => x.ready,
        html<ProductUgc>`
          <iframe
            ${ref('frame')}
            title="Infinite Objects Creator Tool"
            id="ugc-app"
            class="ugc-app-frame"
            src="${(x) => x.applicationHost}"
            sanbox="allow-scripts allow-forms allow-same-origin"
            data-hj-allow-iframe
          >
          </iframe>
        `,
      )}
      <io-theme-dialog ${ref('dialog')}>
        <slot name="size-chart" ${slotted('slottedSizeChartElements')}> </slot>
      </io-theme-dialog>
    </template>
  `
}
